import mortgageProgressApi from "~/api/mortgage_progress";

const setMortgage = async ({ commit }, mortgage) => {
  commit("SET_MORTGAGE", mortgage);
};

const initMortgageProgress = async ({ commit }, mortgageId) => {
  mortgageProgressApi.getByMortgage(mortgageId)
    .then((response) => {
      commit("SET_MORTGAGE_PROGRESSES", response.data);
    });
};

const updateMortgageProgressWithState = async ({ commit }, mortgageProgress, state) => {
  commit("UPDATE_MORTGAGE_PROGRESS_WITH_STATE", mortgageProgress, state);
};

const updateMortgageProgressesWithState = async ({ commit }, mortgageProgresses, state) => {
  mortgageProgresses.forEach((mortgageProgress) => {
    commit("UPDATE_MORTGAGE_PROGRESS_WITH_STATE", mortgageProgress, state);
  });
};

const addDeclineSelectionToSendToAgency = async ({ commit }, mortgageProgress) => {
  commit("ADD_DECLINE_SELECTION_TO_SEND_TO_AGENCY", mortgageProgress);
};

const addDeclineSelectionToBeApproved = async ({ commit }, mortgageProgress) => {
  commit("ADD_DECLINE_SELECTION_TO_BE_APPROVED", mortgageProgress);
};

const addDeclineSelectionApproved = async ({ commit }, mortgageProgress) => {
  commit("ADD_DECLINE_SELECTION_APPROVED", mortgageProgress);
};

const removeDeclineSelectionToSendToAgency = async ({ commit }, mortgageProgress) => {
  commit("REMOVE_DECLINE_SELECTION_TO_SEND_TO_AGENCY", mortgageProgress);
};

const removeDeclineSelectionToBeApproved = async ({ commit }, mortgageProgress) => {
  commit("REMOVE_DECLINE_SELECTION_TO_BE_APPROVED", mortgageProgress);
};

const removeDeclineSelectionApproved = async ({ commit }, mortgageProgress) => {
  commit("REMOVE_DECLINE_SELECTION_APPROVED", mortgageProgress);
};

const clearDeclineSelectionToSendToAgency = async ({ commit }) => {
  commit("CLEAR_DECLINE_SELECTION_TO_SEND_TO_AGENCY");
};

const clearDeclineSelectionToBeApproved = async ({ commit }) => {
  commit("CLEAR_DECLINE_SELECTION_TO_BE_APPROVED");
};

const clearDeclineSelectionApproved = async ({ commit }) => {
  commit("CLEAR_DECLINE_SELECTION_APPROVED");
};

export default {
  setMortgage,
  initMortgageProgress,
  updateMortgageProgressWithState,
  updateMortgageProgressesWithState,
  addDeclineSelectionToSendToAgency,
  addDeclineSelectionToBeApproved,
  addDeclineSelectionApproved,
  removeDeclineSelectionToSendToAgency,
  removeDeclineSelectionToBeApproved,
  removeDeclineSelectionApproved,
  clearDeclineSelectionToSendToAgency,
  clearDeclineSelectionToBeApproved,
  clearDeclineSelectionApproved,
};
